import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { questionsActions } from 'store';
import { ROUTES } from 'utils/routeNames';
import { Button, StyledButtonsWrapper, StyledColesButton } from './styled';

export const ButtonsContent = ({
  answers,
  questions,
  skipped,
  activeStep,
  setAnswerItem,
  setActiveStep,
  setIsChooseAnswer,
  isStepSkipped,
  setSkipped,
  isChooseAnswer,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleNext = () => {
    if (answers[activeStep]) {
      setAnswerItem(answers.find((item) => item.position === activeStep + 1));
    } else {
      setAnswerItem({});
    }

    setIsChooseAnswer(true);

    let newSkipped = skipped;

    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }

    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setAnswerItem(answers.find((item) => item.position === activeStep - 1));
  };

  const handleSubmit = () => {
    setActiveStep(activeStep + 1);
    dispatch(questionsActions.submitQuestionAnswers(answers));
  };

  const closeRequest = () => {
    navigate(ROUTES.REQUESTS);
  };

  if (!questions.data?.length) {
    return null;
  }

  return (
    <StyledButtonsWrapper closeButton={activeStep <= questions.data?.length}>
      {activeStep > 1 && activeStep <= questions.data?.length && (
        <Button disabled={activeStep === 0} onClick={handleBack}>
          Back
        </Button>
      )}

      {activeStep <= questions.data?.length ? (
        <Button
          isChooseAnswer={isChooseAnswer}
          disabled={isChooseAnswer}
          onClick={() =>
            activeStep === questions.data?.length ? handleSubmit() : handleNext()
          }
        >
          {activeStep === questions.data?.length ? 'Submit' : 'Next'}
        </Button>
      ) : (
        <StyledColesButton onClick={closeRequest}>Close</StyledColesButton>
      )}
    </StyledButtonsWrapper>
  );
};
